import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionaryACTypeEntity } from '../types';

@Injectable({
  providedIn: 'root',
})
export class DictionaryACTypesDataService {
  url = '/api/dictionary/ac';

  constructor(private http: HttpClient) {}

  getAll(): Observable<DictionaryACTypeEntity[]> {
    return this.http.get<DictionaryACTypeEntity[]>(this.url);
  }

  addType(request: DictionaryACTypeEntity): Observable<DictionaryACTypeEntity> {
    return this.http.post<DictionaryACTypeEntity>(this.url, request);
  }

  updateType(
    request: DictionaryACTypeEntity
  ): Observable<DictionaryACTypeEntity> {
    return this.http.put<DictionaryACTypeEntity>(this.url, request);
  }
}
